import { render, staticRenderFns } from "./K3L.vue?vue&type=template&id=887fb4d6&"
import script from "./K3L.vue?vue&type=script&lang=js&"
export * from "./K3L.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports